import React from 'react';
import { Link } from 'react-router-dom';
import './TopicSelection.css';

// Topic details
const topics = [
  {
    id: 'bash',
    name: 'Bash Scripting',
    description: 'Learn Bash shell scripting commands and syntax',
    icon: '🐧',
    color: '#4CAF50'
  },
  {
    id: 'terraform',
    name: 'Terraform',
    description: 'Master Terraform commands and HCL syntax',
    icon: '🏗️',
    color: '#7B42BC'
  },
  {
    id: 'linux',
    name: 'Linux Commands',
    description: 'Explore essential Linux commands: grep, awk, sed, and more',
    icon: '💻',
    color: '#F44336'
  },
  {
    id: 'git',
    name: 'Git',
    description: 'Learn Git version control commands and workflows',
    icon: '📝',
    color: '#FF9800'
  },
  {
    id: 'ansible',
    name: 'Ansible',
    description: 'Understand Ansible automation commands and YAML syntax',
    icon: '🔄',
    color: '#2196F3'
  },
  {
    id: 'docker',
    name: 'Docker',
    description: 'Master container management and Docker CLI commands',
    icon: '🐳',
    color: '#2496ED'
  },
  {
    id: 'networking',
    name: 'Networking',
    description: 'Learn curl, netcat, and network diagnostic tools',
    icon: '🌐',
    color: '#00BCD4'
  },
  {
    id: 'vim',
    name: 'Vim Editor',
    description: 'Master the powerful Vim text editor commands',
    icon: '📝',
    color: '#019733'
  }
];

const TopicSelection = () => {
  return (
    <div className="topic-selection">
      <div className="container">
        <div className="header">
          <Link to="/" className="back-link">← Home</Link>
          <h1>Choose a Topic</h1>
          <p>Select a technology to start learning</p>
        </div>

        <div className="topics-grid">
          {topics.map(topic => (
            <Link 
              to={`/learn/${topic.id}`} 
              key={topic.id} 
              className="topic-card"
              style={{ borderColor: topic.color }}
            >
              <div className="topic-icon" style={{ backgroundColor: topic.color }}>
                {topic.icon}
              </div>
              <h2>{topic.name}</h2>
              <p>{topic.description}</p>
            </Link>
          ))}
        </div>
        
        {/* Scenario Challenges */}
        <div className="special-tools">
          <h2>Scenario Challenges</h2>
          <p className="section-subtitle">Test your skills with real-world challenges</p>
          <div className="tools-grid">
            <Link
              to="/scenario/linux"
              className="tool-card scenario-card"
              style={{ borderColor: "#F44336" }}
            >
              <div className="tool-icon" style={{ backgroundColor: "#F44336" }}>
                🕵️
              </div>
              <h2>Linux Scenarios</h2>
              <p>Detective, rescue, and boss battle challenges for Linux</p>
            </Link>
            <Link
              to="/scenario/docker"
              className="tool-card scenario-card"
              style={{ borderColor: "#2496ED" }}
            >
              <div className="tool-icon" style={{ backgroundColor: "#2496ED" }}>
                🐳
              </div>
              <h2>Docker Scenarios</h2>
              <p>Container debugging and deployment challenges</p>
            </Link>
            <Link
              to="/scenario/networking"
              className="tool-card scenario-card"
              style={{ borderColor: "#00BCD4" }}
            >
              <div className="tool-icon" style={{ backgroundColor: "#00BCD4" }}>
                🌐
              </div>
              <h2>Networking Scenarios</h2>
              <p>Troubleshoot connectivity and API integration</p>
            </Link>
            <Link
              to="/scenario/git"
              className="tool-card scenario-card"
              style={{ borderColor: "#FF9800" }}
            >
              <div className="tool-icon" style={{ backgroundColor: "#FF9800" }}>
                📝
              </div>
              <h2>Git Scenarios</h2>
              <p>Rescue missions for version control disasters</p>
            </Link>
          </div>
        </div>

        {/* Interactive Simulators */}
        <div className="special-tools">
          <h2>Interactive Simulators</h2>
          <p className="section-subtitle">Hands-on practice environments</p>
          <div className="tools-grid">
            <Link
              to="/terraform-simulator"
              className="tool-card"
              style={{ borderColor: "#7B42BC" }}
            >
              <div className="tool-icon" style={{ backgroundColor: "#7B42BC" }}>
                🔮
              </div>
              <h2>Terraform Syntax Simulator</h2>
              <p>Interactive HCL syntax editor with validation and examples</p>
            </Link>
            <Link
              to="/vim-simulator"
              className="tool-card"
              style={{ borderColor: "#019733" }}
            >
              <div className="tool-icon" style={{ backgroundColor: "#019733" }}>
                📝
              </div>
              <h2>Interactive Vim Simulator</h2>
              <p>Practice Vim commands with real-time key capture and feedback</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopicSelection;
